module.exports = __webpack_public_path__ + "img/zhaunyeoeixun.4ec38057.jpg";